import {
  GET_DETAILS_PASSPORT_FAILURE,
  GET_DETAILS_PASSPORT_REQUEST,
  GET_DETAILS_PASSPORT_SUCCESS,
  UPDATE_PASSPORT_FAILURE,
  UPDATE_PASSPORT_REQUEST,
  UPDATE_PASSPORT_SUCCESS,
} from "./actionTypes";

const initialState = {
  error: false,
  loading: false,
  data: null,
  success: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DETAILS_PASSPORT_REQUEST:
      console.log("REQUEST");
      state = {
        ...state,
        data: [],
        loading: true,
        error: false,
        success: false,
      };
      break;

    case GET_DETAILS_PASSPORT_SUCCESS:
      console.log("SUCCESS");
      state = {
        ...state,
        data: action.data,
        error: false,
        loading: false,
      };
      break;

    case GET_DETAILS_PASSPORT_FAILURE:
      console.log("FAILURE");
      state = {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
      break;

    case UPDATE_PASSPORT_REQUEST:
      console.log("REQUEST");
      state = {
        ...state,
        data: [],
        loading: true,
        error: false,
        success: false,
      };
      break;

    case UPDATE_PASSPORT_SUCCESS:
      console.log("SUCCESS");
      state = {
        ...state,
        data: action.data,
        error: false,
        loading: false,
        success: true,
      };
      break;

    case UPDATE_PASSPORT_FAILURE:
      console.log("FAILURE");
      state = {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default reducer;
